<template>
    <div class="container mx-auto">
        <section class="hero">
          <div class="wrapper">
            <div class="hero-wrapper">
              <div class="hero-content">
                <h1 class="hero-title">Snipper</h1>
                <p class="hero-text">
                Sweet <i>Snippet manager</i> on the                
                <br>menubar.
                </p>
                <div class="action-buttons">
               <router-link to="/auth" ><button class="primary">6$ Buy now </button></router-link>
                
                </div>
              </div>
              <div class="hero-image">
                <img class="prev-img" src="../assets/mac-img.png" alt="">
              </div>
            </div>
          </div>
        </section>
        <section class="features">
                <h1 class="fea-title">Features</h1>
        </section>
        <section class="preview">
                <h1 class="pre-title">Preview</h1>
        <img src="../assets/Signup.png" alt="">
        <img src="../assets/Create.png" alt="">
        <img src="../assets/snip.png" alt="">
        <img src="../assets/snips.png" alt="">
        <img src="../assets/Search.png" alt="">
        </section>
        <section class="feedback">
        GitHub integration and sync feature <br> coming soon...<br>
        stay Tuned..
        </section>
        <section class="conclusion">
        created in India <br>copyright <a href="https://www.twitter.com/achuth_hadnoor" target ='_blank'>@achuth_hadnoor</a>
        </section>
    </div> 
</template>

<script>
  export default {
    name: 'hello',
    data() {
      return {
        msg: 'Welcome to Your Vue.js PWA'
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
  h1,
  h2 {
    font-weight: normal;
  }

  ul {
    list-style-type: none;
    padding: 0;
  }

  li {
    display: inline-block;
    margin: 0 10px;
  }

  a {
    color:#eee;
  }
</style>



// WEBPACK FOOTER //
// src/components/Hello.vue